<template>
  <el-popover
    :placement="placement"
    :width="width"
    :trigger="trigger"
  >
    <!-- Prefer slot content; fall back to content prop -->
    <slot v-if="$slots.default" />
    <div v-else-if="content" v-html="content"></div>

    <el-button :style="buttonStyle" :type="buttonType" slot="reference">
      {{ buttonText }}
    </el-button>
  </el-popover>
  
</template>

<script>
export default {
  name: 'DisclaimerV2',
  props: {
    placement: { type: String, default: 'bottom' },
    width: { type: [Number, String], default: 800 },
    trigger: { type: String, default: 'hover' },
    buttonText: { type: String, default: '*Disclaimer' },
    buttonType: { type: String, default: 'text' },
    buttonStyle: { type: String, default: 'font-size:12px' },
    // Optional HTML string if you don't use the default slot
    content: { type: String, default: '' },
  },
};
</script>
